import styled from 'styled-components'

export const TwoColumnLayout = styled.div`
  display: flex;
  gap: 3rem;
`

export const MainColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2rem;
`

export const SideColumn = styled.div`
  width: 180px;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const Section = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const SectionContent = styled.div<{isEmpty?:boolean, isLoading?:boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  
  ${props => props?.isEmpty && `
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f9fafb;
    height: 100%;
  `}
  
  ${props => props?.isLoading && `
    display: flex;
    min-height: 200px;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
      animation: shimmer-wave 2s infinite;
    }
  `}
  
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
  
  @keyframes shimmer-wave {
    0% {
      left: -100%;
    }
    100% {
      left: 100%;
    }
  }
`

export const SectionCardItem = styled.li`
  padding: 1rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #fff;
  transition: all 0.2s ease;
  flex-direction: column;
  overflow-x: hidden;
  
  &:hover {
    box-shadow: 0 3px rgba(0, 0, 0, 0.1);
  }

  p {
    font-size: 14px;
    font-weight: 400;
    color: #6b7280;

    &.title {
      font-weight: 500;
      margin-bottom: .5rem;
      color: #172b4d;
    }
  }
`

export const CardHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const ButtonIcons = styled.div`
  display: flex;
  align-items: center;
  gap: .5rem;
`

export const IconButton = styled.span<{colors:string}>`
  color: #6b778c;
  border-radius: 8px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all ease-in .1s;
  :hover {
    color: ${props => `${props.colors} 1)`};
    background-color: ${props => `${props.colors} .1)`};
  }

  &.disabled {
    :hover {
      color: #6b778c;
      background-color: transparent;
    }
  }
`

export const ObsDiv = styled.div`
  border-radius: 8px;
  background-color: #F9FAFB;
  padding: .8rem;
`

export const CardTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #172b4d;
`

export const Text = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #6b7280;
`

export const TextLight = styled.p`
  font-size: 16px;
  font-weight: 300;
  color: #6b7280;
`

export const SectionHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const Button = styled.button`
  padding: 1rem;
  background-color: #0090D3;
  color: #fff;
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all ease .2s;
  
  &:hover {
    background-color: #007bb8;
  }
`

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: #172b4d;
  
  svg {
    margin-right: 4px;
    color: #6b778c;
  }
`

export const SidebarSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: .5rem;
`

export const SidebarButton = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #ebecf0;
  border: none;
  border-radius: 10px;
  padding: .9rem;
  cursor: pointer;
  text-align: left;
  color: #172b4d;
  
  svg {
    margin-right: 4px;
    color: #6b778c;
  }
  
  &:hover {
    background-color: #ebecf0;
  }
`

export const SidebarSectionTitle = styled.h4`
  font-size: 12px;
  text-transform: uppercase;
  color: #6b778c;
  font-weight: 600;
  margin: 0 0 4px 0;
  letter-spacing: 0.5px;
`

export const GeneralList = styled.ul<{border?:string}>`
  display: flex;
  flex-direction: column;
  gap: .5rem;
  list-style: none;
  border: ${props => props?.border ? props.border : 'none'};
  width: 100%;
  padding: 0;
  margin: 0;
`

export const GeneralItem = styled.li`
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const ButtonForMaterials = styled.button<{color?:string, disabled?:boolean}>`
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  color: ${props => props?.color ? props.color : '#0090D3'};
  gap: 4px;
  background-color: transparent;
  font-size: 16px;
  font-weight: 600;
  border: ${props => props?.color ? `2px solid ${props.color}` : '2px solid #0090D3'};
  border-radius: 1rem;
  cursor: pointer;
  transition: all ease .2s;
  opacity: ${props => props?.disabled ? '.5' : '1'};
  cursor: ${props => props?.disabled ? 'not-allowed' : 'pointer'};
  :hover {
    background-color: ${props => props?.color ? props.color : '#0090D3'};
    color: #fff;
    border: ${props => props?.color ? `2px solid ${props.color}` : '2px solid #0090D3'};
  }
`

export const HistoryList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: .2rem;
  list-style: none;
  padding: .5rem 1rem 0 1rem;
`

export const HistoryItem = styled.li`
  display: flex;
  padding: 1rem;
  align-items: center;
  border-radius: 1rem;

  :hover {
    background-color: #ebecf0;
  }
`

export const UserImage = styled.div<{biggest?:boolean}>`
  width: ${props => props?.biggest ? '40px' : '18px'};
  height: ${props => props?.biggest ? '40px' : '18px'};
  border-radius: 50%;
  background-color: #0090D3;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => props?.biggest ? '20px' : '12px'};
  margin-right: .7rem;
`

export const HistoryItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 1rem;
  }
`

export const HistoryItemText = styled.p`
  font-size: 14px;
  color: #172b4d;

  span {
    font-weight: 700;
  }
`

export const WhatTime = styled.span`
  color: rgba(0, 0, 0, .4);
  font-size: 12px;
`

export const SimpleDataList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 1rem;
  padding: .5rem 1rem 0 1rem;
  list-style: none;

  svg {
    width: 14px;
    color: #6b778c;
  }
`

export const SimpleDataItem = styled.li`
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: #EBECF0;
  padding: .5rem;
  border-radius: 10px;
`

export const CommentList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  list-style: none;
  padding: .5rem 1rem 0 1rem;
`

export const CommentItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: .4rem;
`

export const CommentHeader = styled.div`
  display: flex;
  align-items: center;
`

export const CommentText = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, .7);
  border-radius: .2rem;
`

export const InputCommentDiv = styled.div`
  display: flex;
  align-items: center;
`

export const InputComment = styled.input`
  height: 40px;
  resize: none;
  outline: none;
  border: 1px solid #dfe1e6;
  border-radius: 2rem;
  background-color: #EBEBEB;
  padding: 1rem;
  width: 100%;
  margin-top: .5rem;
  margin-bottom: .5rem;
  transition: all ease .1s;

  :focus {
    border: 1px solid #0090D3;
  }
`